
import React from 'react'

import { I18n } from '@front/volcanion'
import { SubmitButton, NumberField, SingleOptionSelectorField } from '@front/squirtle'
import { Box, Grid, Icon, Typography } from '@mui/material'

const PaymentSection = (props) => <>
  <Grid size={12}>
    <NumberField
      name='base'
      type='float'
      precision={1}
      label={I18n.t('quotation.amount')}
      InputProps={{ endAdornment: <Icon color='primary'> {'euro'} </Icon> }}
      required
    />
  </Grid>
  <Grid size={12}>
    <NumberField
      name='fees'
      type='float'
      label={I18n.t('quotation.fees')}
      InputProps={{ endAdornment: <Icon color='primary'> {'euro'} </Icon> }}
    />
  </Grid>
  <Grid size={12}>
    <NumberField
      name="prepaid"
      type='float'
      label={I18n.t('quotation.prepaid')}
      InputProps={{ endAdornment: <Icon color='primary'> {'euro'} </Icon> }}
    />
  </Grid>
  <Grid size={12}>
    <NumberField
      name="option_amount"
      type='float'
      label={I18n.t('quotation.option_amount')}
      InputProps={{ endAdornment: <Icon color='primary'> {'euro'} </Icon> }}
      disabled
    />
  </Grid>
  <Grid size={12}>
    <NumberField
      name="driver_package_fee"
      type='float'
      label={I18n.t('quotation.driver_package_fee')}
      InputProps={{ endAdornment: <Icon color='primary'> {'euro'} </Icon> }}
      disabled
    />
  </Grid>
</>

const SimulatorDialog = ({
  transportStatus,
  transportStatusColor,
  orderStatus,
  orderStatusColor,
  nextButtonLabel,
  isOrderStarted,
  isOrderCompleted,
  isPayment,
  isRedispatchActive,
  isRedispatchPossible
}) => {
  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant={'h5'} color={orderStatusColor} fontWeight={400}>{orderStatus}</Typography>
          <Typography variant={'h5'} marginX={1}>|</Typography>
          <Typography variant={'h5'} color={transportStatusColor} fontWeight={400}>{transportStatus}</Typography>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            {!isPayment && <SingleOptionSelectorField
              name={'disable_notifications'}
              valueType='checkbox'
              optionLabel={I18n.t('transport.do_not_notify_driver')}
              optionValue={true}
              clearOnEmpty={false}
              orientation='vertical'
            />}
          </Box>
        </Box>
      </Grid>
      {!isOrderCompleted && isPayment && <PaymentSection />}
      {!isOrderCompleted &&
        <Grid size={12}>
          <SubmitButton fullWidth extra={{ submitType: isPayment ? 'payment' : 'next' }} label={nextButtonLabel} />
        </Grid>
      }
      {!isOrderCompleted &&
        <Grid size={12}>
          {!isOrderStarted ? (
            <SubmitButton
              disabled={!isRedispatchPossible}
              fullWidth
              extra={{ submitType: !isRedispatchActive ? 'enable_redispatch' : 'cancel_redispatch' }}
              label={!isRedispatchActive ? I18n.t('transport.enable_auto_redispatch') : I18n.t('transport.cancel_auto_redispatch')}
            />
          ) : (
            <SubmitButton fullWidth extra={{ submitType: 'cancel' }} label={I18n.t('transport.status.not_loaded')} />
          )}
        </Grid>
      }
    </Grid>
  );
}

export default React.memo(SimulatorDialog)
